// Level 0: Pure formatting functions — no I/O, no side effects
// Extracted from api.js to separate concerns (utils vs gateways)

// Note: All monetary values in the database are stored in MILLIONS of USD
// e.g., BlackRock AUM = 10,500,000.0 means $10.5 trillion (10,500,000 millions)
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return 'N/A';
  if (amount === 0) return '$0.00';

  // Convert to number if it's a string (backend sometimes returns strings)
  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;

  // Check if valid number
  if (isNaN(numAmount)) return 'N/A';

  // Handle sign for negative numbers
  const isNegative = numAmount < 0;
  const absAmount = Math.abs(numAmount);

  // Data is in millions, so convert thresholds accordingly
  // 1,000,000 (millions) = $1 trillion
  if (absAmount >= 1000000) {
    return `${isNegative ? '-' : ''}$${(absAmount / 1000000).toFixed(2)}T`;
  }
  // 1,000 (millions) = $1 billion
  if (absAmount >= 1000) {
    return `${isNegative ? '-' : ''}$${(absAmount / 1000).toFixed(2)}B`;
  }
  // All other values: show in millions (including values < 1)
  return `${isNegative ? '-' : ''}$${absAmount.toFixed(2)}M`;
};

export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

// Format percentage string
export const formatPercentage = (value) => {
  if (!value) return 'N/A';
  if (typeof value === 'string' && value.includes('%')) return value;
  return `${parseFloat(value).toFixed(1)}%`;
};

// Format large numbers with commas
export const formatNumber = (num) => {
  if (!num) return 'N/A';
  return new Intl.NumberFormat('en-US').format(num);
};

// Format year (removes decimal from floats like 1969.0 -> 1969)
export const formatYear = (year) => {
  if (!year) return 'N/A';
  const parsed = parseInt(year, 10);
  if (isNaN(parsed)) return 'N/A';
  return parsed.toString();
};
